"use strict";
export var KeyAction = /* @__PURE__ */ ((KeyAction2) => {
  KeyAction2["UP"] = "keyup";
  KeyAction2["DOWN"] = "keydown";
  return KeyAction2;
})(KeyAction || {});
